// src/v3/account/email.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var EmailIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "EmailIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M21 4.5H3a.75.75 0 0 0-.75.75V18a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25A.75.75 0 0 0 21 4.5ZM19.072 6 12 12.483 4.928 6h14.144Zm1.178 12H3.75V6.955l7.743 7.098a.75.75 0 0 0 1.014 0l7.743-7.098V18Z"
  }
) });

export {
  EmailIcon
};
